export default __webpack_public_path__ + "static/media/add_to_photos.781de26d.svg";